<template>
  <!-- 单个课程的编辑卡片（课程一 / 课程二 ... 之一） -->
  <div class="gen-course" :class="{ 'is-dirty': isDirty }">
    <!-- AI 智能提取（一个文件拆分三字段） -->
    <div class="gen-summary-section">
      <div class="gen-summary-label"><i class="el-icon-magic-stick" style="color:#7c3aed;margin-right:4px;"></i>AI 智能提取</div>
      <div
        class="gen-upload-drop gen-upload-drop--purple"
        :class="{ 'is-dragover': aiExtractDragover, 'is-loading': aiExtractLoading }"
        @dragover.prevent="aiExtractDragover = true"
        @dragleave.prevent="aiExtractDragover = false"
        @drop.prevent="handleAiExtractDrop($event)"
        @click="!aiExtractLoading && triggerAiExtractInput()"
      >
        <div v-if="aiExtractLoading" class="gen-upload-drop__glass gen-upload-drop__glass--purple">
          <i class="el-icon-loading"></i>
          <span>AI 正在分析提取...</span>
        </div>
        <input ref="aiExtractInput" type="file" :accept="acceptTypes" style="display:none" @change="handleAiExtractSelect($event)" />
        <div class="gen-upload-drop__header">
          <i class="el-icon-upload2"></i>
          <span>拖拽文件到此处或<em>点击上传</em></span>
        </div>
        <div class="gen-upload-drop__desc">上传一份文件，AI 自动识别并拆分填充到「课程大纲」「讲师简介」「其他补充」三个字段</div>
        <div class="gen-upload-drop__tip">支持 Word / Excel / PPT / PDF / 纯文本文件</div>
      </div>
    </div>

    <!-- 主讲老师 -->
    <div ref="field-wordMainTeacher" class="gen-summary-section" :class="{ 'is-error': fieldErrors.wordMainTeacher }">
      <div class="gen-summary-label gen-summary-label--required">主讲老师</div>
      <el-input v-model="localForm.wordMainTeacher" size="small" placeholder="请输入主讲老师姓名" @input="clearFieldError('wordMainTeacher')" />
    </div>

    <!-- 讲师简介 -->
    <div ref="field-wordTeacherUser" class="gen-summary-section" :class="{ 'is-error': fieldErrors.wordTeacherUser }">
      <div class="gen-summary-label">讲师简介</div>
      <div
        class="gen-upload-drop gen-upload-drop--blue"
        :class="{ 'is-dragover': uploadDragover.wordTeacherUser, 'is-loading': uploadLoading.wordTeacherUser }"
        @dragover.prevent="uploadDragover.wordTeacherUser = true"
        @dragleave.prevent="uploadDragover.wordTeacherUser = false"
        @drop.prevent="handleFileDrop($event, 'wordTeacherUser')"
        @click="!uploadLoading.wordTeacherUser && triggerFileInput('wordTeacherUser')"
      >
        <div v-if="uploadLoading.wordTeacherUser" class="gen-upload-drop__glass gen-upload-drop__glass--blue">
          <i class="el-icon-loading"></i>
          <span>正在提取文本...</span>
        </div>
        <input ref="wordTeacherUserInput" type="file" :accept="acceptTypes" style="display:none" @change="handleFileSelect($event, 'wordTeacherUser')" />
        <div class="gen-upload-drop__header">
          <i class="el-icon-upload2"></i>
          <span>拖拽文件到此处或<em>点击上传</em></span>
        </div>
        <div class="gen-upload-drop__desc">上传讲师简介文件，自动提取文本内容填充到下方输入框</div>
        <div class="gen-upload-drop__tip">支持 Word / Excel / PPT / PDF / 纯文本文件</div>
      </div>
      <el-input
        v-model="localForm.wordTeacherUser"
        type="textarea"
        :rows="6"
        placeholder="请输入讲师简介内容，或通过上方上传文件自动填充"
        @input="clearFieldError('wordTeacherUser')"
      />
    </div>

    <!-- 课程名称 -->
    <div ref="field-wordCourseName" class="gen-summary-section" :class="{ 'is-error': fieldErrors.wordCourseName }">
      <div class="gen-summary-label gen-summary-label--required">课程名称</div>
      <el-input v-model="localForm.wordCourseName" size="small" placeholder="请输入本课程名称（如：AI工具赋能）" @input="clearFieldError('wordCourseName')" />
    </div>

    <!-- 课程大纲 -->
    <div ref="field-wordCourseOutline" class="gen-summary-section" :class="{ 'is-error': fieldErrors.wordCourseOutline }">
      <div class="gen-summary-label gen-summary-label--required">课程大纲</div>
      <div
        class="gen-upload-drop gen-upload-drop--green"
        :class="{ 'is-dragover': uploadDragover.wordCourseOutline, 'is-loading': uploadLoading.wordCourseOutline }"
        @dragover.prevent="uploadDragover.wordCourseOutline = true"
        @dragleave.prevent="uploadDragover.wordCourseOutline = false"
        @drop.prevent="handleFileDrop($event, 'wordCourseOutline')"
        @click="!uploadLoading.wordCourseOutline && triggerFileInput('wordCourseOutline')"
      >
        <div v-if="uploadLoading.wordCourseOutline" class="gen-upload-drop__glass gen-upload-drop__glass--green">
          <i class="el-icon-loading"></i>
          <span>正在提取文本...</span>
        </div>
        <input ref="wordCourseOutlineInput" type="file" :accept="acceptTypes" style="display:none" @change="handleFileSelect($event, 'wordCourseOutline')" />
        <div class="gen-upload-drop__header">
          <i class="el-icon-upload2"></i>
          <span>拖拽文件到此处或<em>点击上传</em></span>
        </div>
        <div class="gen-upload-drop__desc">上传课程大纲文件，自动提取文本内容填充到下方输入框</div>
        <div class="gen-upload-drop__tip">支持 Word / Excel / PPT / PDF / 纯文本文件</div>
      </div>
      <el-input
        v-model="localForm.wordCourseOutline"
        type="textarea"
        :rows="6"
        placeholder="请输入课程大纲，或通过上方上传文件自动填充"
        @input="clearFieldError('wordCourseOutline')"
      />
    </div>

    <!-- 其他补充信息 -->
    <div class="gen-summary-section">
      <div class="gen-summary-label">其他补充</div>
      <div
        class="gen-upload-drop gen-upload-drop--orange"
        :class="{ 'is-dragover': uploadDragover.wordCourseOther, 'is-loading': uploadLoading.wordCourseOther }"
        @dragover.prevent="uploadDragover.wordCourseOther = true"
        @dragleave.prevent="uploadDragover.wordCourseOther = false"
        @drop.prevent="handleFileDrop($event, 'wordCourseOther')"
        @click="!uploadLoading.wordCourseOther && triggerFileInput('wordCourseOther')"
      >
        <div v-if="uploadLoading.wordCourseOther" class="gen-upload-drop__glass gen-upload-drop__glass--orange">
          <i class="el-icon-loading"></i>
          <span>正在提取文本...</span>
        </div>
        <input ref="wordCourseOtherInput" type="file" :accept="acceptTypes" style="display:none" @change="handleFileSelect($event, 'wordCourseOther')" />
        <div class="gen-upload-drop__header">
          <i class="el-icon-upload2"></i>
          <span>拖拽文件到此处或<em>点击上传</em></span>
        </div>
        <div class="gen-upload-drop__desc">上传课程背景、目标、规划等相关文件，自动提取填充</div>
        <div class="gen-upload-drop__tip">支持 Word / Excel / PPT / PDF / 纯文本文件</div>
      </div>
      <div class="gen-summary-label gen-summary-label--sub">用户提示词</div>
      <el-input
        v-model="localForm.wordUserPrompt"
        type="textarea"
        :rows="3"
        placeholder="请输入补充提示词，帮助 AI 更精准地生成报告内容"
      />
      <el-input
        v-model="localForm.wordCourseOther"
        type="textarea"
        :rows="4"
        placeholder="有课程背景、目标、规划、形式等相关内容的请提供，或通过上方上传文件自动填充"
      />
    </div>

    <!-- 操作按钮（暂存 / AI 生成） -->
    <div class="gen-summary-action-btns">
      <el-button
        size="small"
        icon="el-icon-folder-opened"
        :loading="saveLoading"
        @click="handleSave(2)"
      >暂存</el-button>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-magic-stick"
        :loading="submitLoading"
        @click="handleSave(1)"
      >AI 生成</el-button>
    </div>
  </div>
</template>

<script>
import {
  addRtReportModelUserSignMergeWordAi,
  updateRtReportModelUserSignMergeWordAi,
  getExtractFileText,
  getExtractFileTextAnalyzeAi
} from '@/api/api'

export default {
  name: 'ReportGenSummaryCourse',
  props: {
    // 课程数据（来自报告内容记录列表）
    course: { type: Object, default: null },
    // 接口字段描述，用于 placeholder 提示（可选）
    fieldHints: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      // 当前课程编辑表单（与本课程 word 记录字段一一对应）
      localForm: this.buildEmptyForm(),
      // 服务端最新已保存快照，用于判断是否有改动
      savedSnapshot: this.buildEmptyForm(),
      saveLoading: false,
      submitLoading: false,
      // 文件上传提取相关
      acceptTypes: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.csv,.log,.md,.json,.xml,.html,.yml,.yaml',
      uploadLoading: { wordTeacherUser: false, wordCourseOutline: false, wordCourseOther: false },
      uploadDragover: { wordTeacherUser: false, wordCourseOutline: false, wordCourseOther: false },
      aiExtractLoading: false,
      aiExtractDragover: false,
      // 必填字段错误标记（用于输入框标红 + 滚动定位）
      fieldErrors: {
        wordMainTeacher: false,
        wordTeacherUser: false,
        wordCourseName: false,
        wordCourseOutline: false
      }
    }
  },
  computed: {
    // 是否已存在记录（新增 vs 编辑）
    isExisting () {
      return !!(this.course && this.course.rrmusmWordId)
    },
    // 是否相对已保存内容有改动（用于状态判定）
    isDirty () {
      return JSON.stringify(this.localForm) !== JSON.stringify(this.savedSnapshot)
    },
    // 课程保存状态：未保存 / 已暂存 / 已生成
    statusType () {
      if (this.isDirty) return 'dirty' // 有未保存改动
      if (!this.isExisting) return 'unsaved' // 新课程尚未提交
      if (!this.course.wordTextAi) return 'draft' // 已暂存但未 AI 生成
      return 'saved' // 已 AI 生成
    }
  },
  watch: {
    course: {
      immediate: true,
      deep: false,
      handler (val) {
        const form = this.buildFormFromCourse(val)
        this.localForm = form
        this.savedSnapshot = { ...form }
      }
    }
  },
  methods: {
    buildEmptyForm () {
      return {
        wordMainTeacher: '',
        wordTeacherUser: '',
        wordCourseName: '',
        wordCourseOutline: '',
        wordCourseOther: '',
        wordUserPrompt: ''
      }
    },
    // 从课程记录构建表单
    buildFormFromCourse (val) {
      if (!val) return this.buildEmptyForm()
      return {
        wordMainTeacher: val.wordMainTeacher || '',
        wordTeacherUser: val.wordTeacherUser || '',
        wordCourseName: val.wordCourseName || '',
        wordCourseOutline: val.wordCourseOutline || '',
        wordCourseOther: val.wordCourseOther || '',
        wordUserPrompt: val.wordUserPrompt || ''
      }
    },
    // 父组件可通过 ref 获取当前状态
    getStatus () {
      return this.statusType
    },
    // 父组件可调用的重置方法
    resetDirty () {
      const form = this.buildFormFromCourse(this.course)
      this.localForm = form
      this.savedSnapshot = { ...form }
    },

    // 暂存 / 提交（submitStatus: 1=提交触发AI, 2=暂存）
    async handleSave (submitStatus) {
      const isSubmit = submitStatus === 1
      if (isSubmit) {
        // 提交（触发 AI）需校验课程必填项：未填的标红并滚动定位
        if (!this.validateRequiredFields()) return
        // AI 生成流程：先通知父组件保存报告参数，成功后再回调 doSubmitAi 调优化接口
        this.submitLoading = true
        this.$emit('busy-change', true)
        this.$emit('ai-generating', true)
        this.$emit('request-ai') // 父组件保存参数后会调用 this.$refs.courseEditor.doSubmitAi()
        return
      }
      await this.doSave(submitStatus)
    },

    // 暂存（submitStatus=2）保存逻辑
    async doSave (submitStatus) {
      const loadingKey = submitStatus === 1 ? 'submitLoading' : 'saveLoading'
      this[loadingKey] = true
      this.$emit('busy-change', true)
      try {
        const params = {
          ...this.localForm,
          submitStatus
        }
        let res
        if (this.isExisting) {
          params.rrmusmWordId = this.course.rrmusmWordId
          res = await updateRtReportModelUserSignMergeWordAi(params)
        } else {
          params.rrmusmId = this.course.rrmusmId
          res = await addRtReportModelUserSignMergeWordAi(params)
        }
        const newRecord = res.data
        if (newRecord) {
          this.$emit('saved', newRecord, submitStatus === 1)
          const form = this.buildFormFromCourse(newRecord)
          this.localForm = form
          this.savedSnapshot = { ...form }
        }
        this.$message.success(submitStatus === 1 ? 'AI 生成完成' : '暂存成功')
      } catch (e) {
        this.$message.error(e.message || (submitStatus === 1 ? 'AI 生成失败，请稍后重试' : '暂存失败，请稍后重试'))
      } finally {
        this[loadingKey] = false
        this.$emit('busy-change', false)
        if (submitStatus === 1) this.$emit('ai-generating', false)
      }
    },

    // AI 优化接口调用（由父组件保存参数成功后回调）
    async doSubmitAi () {
      try {
        const params = { ...this.localForm, submitStatus: 1 }
        let res
        if (this.isExisting) {
          params.rrmusmWordId = this.course.rrmusmWordId
          res = await updateRtReportModelUserSignMergeWordAi(params)
        } else {
          params.rrmusmId = this.course.rrmusmId
          res = await addRtReportModelUserSignMergeWordAi(params)
        }
        const newRecord = res.data
        if (newRecord) {
          this.$emit('saved', newRecord, true)
          const form = this.buildFormFromCourse(newRecord)
          this.localForm = form
          this.savedSnapshot = { ...form }
        }
        this.$message.success('AI 生成完成')
      } catch (e) {
        this.$message.error(e.message || 'AI 生成失败，请稍后重试')
      } finally {
        this.submitLoading = false
        this.$emit('busy-change', false)
        this.$emit('ai-generating', false)
      }
    },

    // 必填项校验：返回 true 全部通过；false 已标红+滚动到第一个未填项
    validateRequiredFields () {
      const fields = [
        { key: 'wordCourseName', label: '课程名称' },
        { key: 'wordCourseOutline', label: '课程大纲' },
        { key: 'wordMainTeacher', label: '主讲老师' },
        { key: 'wordTeacherUser', label: '讲师简介' }
      ]
      // 先重置
      Object.keys(this.fieldErrors).forEach(k => { this.fieldErrors[k] = false })
      let firstMissing = null
      fields.forEach(f => {
        const val = (this.localForm[f.key] || '').trim()
        if (!val) {
          this.fieldErrors[f.key] = true
          if (!firstMissing) firstMissing = f
        }
      })
      if (firstMissing) {
        this.$message.warning(`请填写${firstMissing.label}`)
        this.scrollToField(firstMissing.key)
        return false
      }
      return true
    },

    // 清除单个字段错误标记
    clearFieldError (key) {
      this.fieldErrors[key] = false
    },

    // 滚动到指定字段并高亮
    scrollToField (key) {
      this.$nextTick(() => {
        const refName = `field-${key}`
        const el = this.$refs[refName]
        if (el) {
          if (el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
          // 添加临时高亮闪烁
          el.classList.add('is-flash')
          setTimeout(() => el.classList.remove('is-flash'), 1600)
        }
      })
    },

    // ============ AI 智能提取（一个文件拆分三字段） ============
    triggerAiExtractInput () {
      this.$refs.aiExtractInput.click()
    },
    handleAiExtractSelect (e) {
      const file = e.target.files && e.target.files[0]
      if (file) this.aiExtractAndFill(file)
      e.target.value = ''
    },
    handleAiExtractDrop (e) {
      this.aiExtractDragover = false
      const file = e.dataTransfer.files && e.dataTransfer.files[0]
      if (file) this.aiExtractAndFill(file)
    },
    async aiExtractAndFill (file) {
      const allowedExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'csv', 'log', 'md', 'json', 'xml', 'html', 'yml', 'yaml']
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      if (!allowedExts.includes(ext)) {
        this.$message.warning('不支持的文件格式，请上传 Word/Excel/PPT/PDF/文本文件')
        return
      }
      this.aiExtractLoading = true
      try {
        const res = await getExtractFileTextAnalyzeAi({ file })
        let data = res.data || res
        if (typeof data === 'string') {
          try { data = JSON.parse(data) } catch (e) { data = {} }
        }
        const outline = data.courseOutline || data.outline || ''
        const intro = data.wordTeacherUser || data.teacherIntro || data.intro || ''
        const other = data.courseOther || data.other || ''
        if (outline) this.localForm.wordCourseOutline = outline
        if (intro) this.localForm.wordTeacherUser = intro
        if (other) this.localForm.wordCourseOther = other
        if (outline || intro || other) {
          this.$message.success('AI 智能提取完成，已自动填充三个字段')
        } else {
          this.$message.info('AI 未提取到有效内容，请检查文件')
        }
      } catch (e) {
        this.$message.error(e.message || 'AI 智能提取失败，请稍后重试')
      } finally {
        this.aiExtractLoading = false
      }
    },

    // ============ 单字段文件上传提取文本 ============
    triggerFileInput (field) {
      const refMap = { wordTeacherUser: 'wordTeacherUserInput', wordCourseOutline: 'wordCourseOutlineInput', wordCourseOther: 'wordCourseOtherInput' }
      const input = this.$refs[refMap[field]]
      if (input) input.click()
    },
    handleFileSelect (e, field) {
      const file = e.target.files && e.target.files[0]
      if (file) this.uploadAndExtract(file, field)
      e.target.value = ''
    },
    handleFileDrop (e, field) {
      this.uploadDragover[field] = false
      const file = e.dataTransfer.files && e.dataTransfer.files[0]
      if (file) this.uploadAndExtract(file, field)
    },
    async uploadAndExtract (file, field) {
      const allowedExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'csv', 'log', 'md', 'json', 'xml', 'html', 'yml', 'yaml']
      const ext = (file.name.split('.').pop() || '').toLowerCase()
      if (!allowedExts.includes(ext)) {
        this.$message.warning('不支持的文件格式，请上传 Word/Excel/PPT/PDF/文本文件')
        return
      }
      this.uploadLoading[field] = true
      try {
        const res = await getExtractFileText({ file })
        const text = res.data || ''
        if (text) {
          this.localForm[field] = this.localForm[field] ? this.localForm[field] + '\n' + text : text
          this.$message.success('文件内容已提取并填充')
        } else {
          this.$message.info('文件中未提取到文本内容')
        }
      } catch (e) {
        this.$message.error(e.message || '文件提取失败，请稍后重试')
      } finally {
        this.uploadLoading[field] = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gen-course {
  display: flex;
  flex-direction: column;
}

.gen-summary-section {
  margin-bottom: 14px;
  &:last-child { margin-bottom: 0; }
}

.gen-summary-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;

  &--required::before { content: '* '; color: #f56c6c; }
  &--sub { font-size: 12px; font-weight: 500; color: #64748b; margin-top: 10px; }
}

.gen-summary-action-btns {
  display: flex;
  gap: 10px;
  margin-top: 4px;
  padding-top: 12px;
  border-top: 1px dashed #e2e8f0;
}

// 拖拽上传区域（与父组件风格一致）
.gen-upload-drop {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 10px;
  padding: 14px 18px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;

  &.is-loading { pointer-events: none; }

  &--blue {
    border: 1.5px dashed #93c5fd;
    background: linear-gradient(135deg, #eff6ff, #dbeafe);
    &:hover, &.is-dragover { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12); }
    .gen-upload-drop__header i { color: #3b82f6; }
    .gen-upload-drop__header em { color: #2563eb; }
    .gen-upload-drop__tip { color: rgba(37, 99, 235, 0.55); }
  }
  &--green {
    border: 1.5px dashed #6ee7b7;
    background: linear-gradient(135deg, #ecfdf5, #d1fae5);
    &:hover, &.is-dragover { border-color: #10b981; box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.12); }
    .gen-upload-drop__header i { color: #10b981; }
    .gen-upload-drop__header em { color: #059669; }
    .gen-upload-drop__tip { color: rgba(5, 150, 105, 0.55); }
  }
  &--orange {
    border: 1.5px dashed #fdba74;
    background: linear-gradient(135deg, #fff7ed, #ffedd5);
    &:hover, &.is-dragover { border-color: #f97316; box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.12); }
    .gen-upload-drop__header i { color: #f97316; }
    .gen-upload-drop__header em { color: #ea580c; }
    .gen-upload-drop__tip { color: rgba(234, 88, 12, 0.55); }
  }
  &--purple {
    border: 1.5px dashed #c4b5fd;
    background: linear-gradient(135deg, #f5f3ff, #ede9fe);
    &:hover, &.is-dragover { border-color: #7c3aed; box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12); }
    .gen-upload-drop__header i { color: #7c3aed; }
    .gen-upload-drop__header em { color: #6d28e9; }
    .gen-upload-drop__tip { color: rgba(109, 40, 217, 0.55); }
  }
}

.gen-upload-drop__header {
  display: flex; align-items: center; gap: 6px;
  font-size: 13px; font-weight: 500; color: #475569;
  i { font-size: 18px; } em { font-style: normal; }
}
.gen-upload-drop__desc { font-size: 12px; color: #64748b; line-height: 1.5; }
.gen-upload-drop__tip { font-size: 11px; margin-top: 2px; }

.gen-upload-drop__glass {
  position: absolute; top: 0; left: 0; right: 0; bottom: 0;
  border-radius: 10px;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
  z-index: 10;
  backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
  i { font-size: 24px; } span { font-size: 13px; font-weight: 500; }
  &--blue { background: rgba(59, 130, 246, 0.28); i, span { color: #1d4ed8; } }
  &--green { background: rgba(16, 185, 129, 0.28); i, span { color: #047857; } }
  &--orange { background: rgba(249, 115, 22, 0.28); i, span { color: #c2410c; } }
  &--purple { background: rgba(124, 58, 237, 0.28); i, span { color: #5b21b6; } }
}

// 必填校验：未填字段输入框边框变红
.gen-summary-section.is-error {
  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    border-color: #f56c6c !important;
    background: #fef0f0 !important;
    &:focus { border-color: #f56c6c !important; }
  }
}
// 滚动定位后的高亮闪烁
.gen-summary-section.is-flash {
  animation: courseFieldFlash 1.6s ease-out;
}
@keyframes courseFieldFlash {
  0%   { background: rgba(245, 108, 108, 0.25); box-shadow: 0 0 0 4px rgba(245, 108, 108, 0.15); }
  30%  { background: rgba(245, 108, 108, 0.12); }
  100% { background: transparent; box-shadow: none; }
}
</style>
